import { Chip } from "@mui/material";

import VuiTooltip from "components/VuiTooltip";

import rgba from "assets/theme/functions/rgba";

import { FLAG_CONFIG } from "variables";

const GuestFlagChip = ({ flag, size = "small", maxWidth = 135, showTooltip = true }) => {
  if (!flag) return null;

  const type = typeof flag === "string" ? flag : flag?.type || flag?.flagType || "";

  const config = FLAG_CONFIG[type];

  if (!config) return null;

  const Icon = config.icon;

  const reason = typeof flag === "object" ? flag?.reason || flag?.message || "" : "";

  const chip = (
    <Chip
      size={size}
      icon={<Icon size={9} color={config.color} />}
      label={config.label}
      sx={{
        flexShrink: 0,
        maxWidth,
        height: 24,
        color: config.color,
        background: rgba(config.color, 0.1),
        border: `1px solid ${rgba(config.color, 0.3)}`,
        fontSize: "9px",
        cursor: "pointer",

        "& .MuiChip-label": {
          px: 0.8,
          overflow: "hidden",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
        },

        "& .MuiChip-icon": {
          ml: 0.8,
          color: config.color,
        },
      }}
    />
  );

  if (!showTooltip) {
    return chip;
  }

  return <VuiTooltip title={reason || config.label}>{chip}</VuiTooltip>;
};

export default GuestFlagChip;
